<script>
    import { link } from "svelte-spa-router";
    export let params = {};
    let verifying = true;
    let verified = false;

    fetch("https://api.plithos.fund/verifyFund?fund_id="+params.fund_id+"&code="+params.code,
        {
            method: "POST",
            headers: {
                "Authorization": "Basic womp"
            }
        }
    )
    .then(res => {
        verifying = false
        if (res.status == 200) verified = true
    })
    .catch(res => verifying = false)

</script>

{#if verifying}
    Verifying...
{:else}
    {#if verified}
        <div style="display: flex; flex-direction: column; align-items: center;">
            <h2>
                Your Fund Has Been Verified!
            </h2>
            
            <a use:link={"/fund/"+params.fund_id}>
                <button 
                    class="fc b dim br2 ph3 pv2 mb2 dib white bg-brand-green">
                    View Your Fund
                </button>
            </a>
        </div>
    {:else}
        Failed to verify
    {/if}
{/if}
